module.exports = __webpack_public_path__ + "static/sti-394673ff98b181f80a6a34d723cfbab5.png";